import Header from './Header';
import Footer from './Footer';
import Slider from './Slider';
import IpNoAvailableModal from './IpNoAvailableModal';

export {
  Header,
  Footer,
  Slider,
  IpNoAvailableModal,
}



// WEBPACK FOOTER //
// ./src/common/index.js